import React, { useCallback } from 'react';
import { componentWillAppendToBody } from 'react-append-to-body';
import styled from 'styled-components';

import { animations, useKeypress } from '../../../core';

export interface BaseModalProps {
  onClose: () => void;
  children?: React.ReactNode;
  justify?: 'flex-start' | 'center' | 'flex-end';
  position?: 'absolute' | 'fixed';
}

const Background = styled.div<{ position?: 'absolute' | 'fixed' }>`
  inset: 0;
  position: ${({ position }) => (position ? position : 'fixed')};
  display: flex;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: ${({ position }) => (position ? '200vh' : '100%')};
  z-index: 1021;
`;

const Scroll = styled.div<{ justify?: 'flex-start' | 'center' | 'flex-end' }>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ justify }) => (justify ? justify : 'center')};
  margin: ${({ justify }) => (justify === 'flex-start' ? '5rem 0' : 'auto')};
  align-items: center;
  width: 100%;
  height: 100%;
`;

const ModalCard = styled.div`
  animation: ${animations.fadeAndSlideInFromTop} 0.2s ease-out forwards;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BaseModal = ({ children, onClose, justify, position }: BaseModalProps) => {
  useKeypress('Escape', () => {
    onClose();
  });

  const handleBackgroundClick = useCallback(
    (clickEvent) => {
      if (clickEvent.currentTarget !== clickEvent.target) {
        return;
      }
      onClose();
    },
    [onClose]
  );

  return (
    <Background onClick={handleBackgroundClick} position={position}>
      <Scroll onClick={handleBackgroundClick} justify={justify}>
        <ModalCard>{children}</ModalCard>
      </Scroll>
    </Background>
  );
};

export default componentWillAppendToBody(BaseModal);
